import ClientsPage from '../Clients/ClientsPage';

export default ClientsPage;